import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PersonPhoneService } from '../person-phone.service';
import { PersonPhone } from '../person-phone';
import { PersonPhoneComponent } from '../person-phone/person-phone.component';
import { PersonService } from '@app/_components/person';

@Component({
    selector: 'app-person-phone-list',
    templateUrl: './person-phone-list.component.html',
    styleUrls: ['./person-phone-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PersonPhoneListComponent implements OnInit {
	constructor(
		private personService: PersonService,
		private personPhoneService: PersonPhoneService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = personPhoneService.statuses;
		this.phoneTypes =  this.personService.phoneTypes;
	}



	// data
	@Input() personId: any;
	personPhones: any;
	personPhone: PersonPhone;
	phoneTypes: any;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'personPhoneId', header: 'Id', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'countryCode', header: 'Country Code', width: 'auto' },
		{ field: 'phoneNum', header: 'Phone Number', width: 'auto' },
		/*{ field: 'personId', header: 'PersonId', width: 'auto' },*/
	];
	
	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.personPhoneId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-personPhone-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.personId)
			{
				// show only activities that are assigned to this activityProviderId
				let personIdFilter = { 'personId': { 'value': this.personId, 'matchMode': 'in' } };
				Object.assign(event.filters, personIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.personPhoneService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data;
						this.recordTotal = res.page.recordTotal;
						this.personPhones = res.data.phones;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.personPhones = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(personPhone: PersonPhone) {
		try {
			this.formLoading = true;
			this.personPhoneService.update(personPhone)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.personPhones.map((personPhone, i) => {
							if (personPhone.personPhoneId === res.data.personPhone.personPhoneId) {
								this.personPhones[i] = res.data.personPhone;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(personPhone: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(personPhone));

			this.formLoading = true;
			this.personPhoneService.delete(personPhone.personPhoneId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.personPhones.splice(this.personPhones.indexOf(personPhone), 1);
						this.recordTotal = this.personPhones.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PersonPhone ' + personPhone.personPhoneId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PersonPhone ' + personPhone.personPhoneId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Phone',
			personId: this.personId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonPhoneComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPersonPhoneCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(personPhone: PersonPhone) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			personPhone: personPhone,
			personId: this.personId,
			title: 'Edit Phone'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PersonPhoneComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePersonPhoneCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePersonPhoneCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPersonPhoneCB(personPhone: PersonPhone) {
		console.log('Adding PersonPhone: ' + JSON.stringify(personPhone));
		// if we don't have a personPhones array yet...
		if (!this.personPhones) {
			this.personPhones = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.personPhones.unshift(personPhone);

		// no idea what this is but it is required to update the array
		this.personPhones = [...this.personPhones];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonPhone ' + personPhone.personPhoneId + ' Added', life: 3000 });
	}

	updatePersonPhoneCB(personPhone: PersonPhone) {
		console.log('Updating PersonPhone: ' + JSON.stringify(personPhone));
		let itemIndex = this.personPhones.findIndex((item: any) => item.personPhoneId === personPhone.personPhoneId);
		this.personPhones[itemIndex] = personPhone;

		// no idea what this is but it is required to update the array
		this.personPhones = [...this.personPhones];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonPhone ' + personPhone.personPhoneId + ' Updated', life: 3000 });
	}

	deletePersonPhoneCB(personPhone: PersonPhone) {
		console.log('Removing PersonPhone: ' + personPhone);
		this.personPhones.splice(this.personPhones.indexOf(personPhone), 1);
		this.recordTotal = this.personPhones.length;

		// no idea what this is but it is required to update the array
		this.personPhones = [...this.personPhones];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PersonPhone ' + personPhone.personPhoneId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.personPhones ? this.first === (this.personPhones.length - this.rows) : true; }
	isFirstPage(): boolean { return this.personPhones ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(personPhone: any) {
		if (personPhone?.status) {
			const status = this.statuses.find((e: any) => e.value == personPhone.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getPhoneType(personPhone: any) {
		if (personPhone?.type) {
			const status = this.phoneTypes.find((e: any) => e.value == personPhone.type);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
